import { Component, effect, Inject, input, OnInit, output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SETTINGS_SERVICE } from '../../../common/constants/injection-tokens';
import { SettingsModel } from '../../../common/models/settings.model';
import { BaseSettingsGetService } from '../../../common/services/base-settings.service';
import { FormGroup } from '@angular/forms';
import { startWith } from 'rxjs/operators';

@Component({
    selector: 'lib-learning-path-card',
    templateUrl: './learning-path-card.component.html',
    styleUrls: ['./learning-path-card.component.scss'],
    host: {
      '[class.learning-path-card--container]': 'responsiveMode() === \'container\'',
      '[class.learning-path-card--viewport]': 'responsiveMode() === \'viewport\'',
    },
    standalone: false
})
export class LearningPathCardComponent implements OnInit {

  public item = input<any>();
  public responsiveMode = input<'viewport' | 'container'>('viewport');
  public startButtonLoading = input(new BehaviorSubject(false));
  public settingsForm = input<FormGroup>();

  public get settings(): SettingsModel {
    return this._settings;
  }

  public onStart = output<void>();

  public cardsSettings: any;

  public leaderboardEnabled = false;
  public certificatesEnabled = false;
  public achievementsEnabled = false;

  private _settings: SettingsModel;

  constructor(
    @Inject(SETTINGS_SERVICE) private readonly settingsService: BaseSettingsGetService,
  ) {
    effect((onCleanup) => {
      const settingsForm = this.settingsForm();

      if (!settingsForm) {
        return;
      }

      const subscription = settingsForm.valueChanges.pipe(
        startWith(settingsForm.value)
      ).subscribe(settings => {
        this._settings = settingsForm.value;
        this.setSettings(settings);
      });

      onCleanup(() => subscription.unsubscribe());
    });
  }

  ngOnInit(): void {
    if (!this.settings) {
      this.settingsService.getSettings().subscribe(settings => {
        this.setSettings(settings);
      })
    }
  }

  public start(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.onStart.emit();
  }

  private setSettings(settings: SettingsModel): void {
    this.cardsSettings = settings.layout.cards;
    this.leaderboardEnabled = settings.features?.leaderboard;
    this.achievementsEnabled = settings.features?.achievements;
    this.certificatesEnabled = settings.features?.certificates;
  }

}
